import type { InfoMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import { MorphemeInfoPanelDictionaryStatRow } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.dictionary.__sections.overview._sections.stat-row";
import { useCardFrequencyRank } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.rank";
import ordinal from "@-/com.npmjs.ordinal";
import { stringLength } from "@-/com.npmjs.string-length";
import { View } from "@-/com.npmjs.react-native";

function characterOrWordRankLabel(infoBackCardSlice: InfoMorphemeSlice): string {
  if (infoBackCardSlice.morphemeType === "word") {
    return "Word Rank";
  }
  if (
    infoBackCardSlice.morphemeType === "grapheme" &&
    stringLength(infoBackCardSlice.grapheme) > 1
  ) {
    return "Word Rank";
  }
  return "Character Rank";
}

function RankRow({ label, rank }: { label: string; rank: number | null }) {
  return (
    <MorphemeInfoPanelDictionaryStatRow
      label={`${label}:`}
      value={rank === null ? "-" : ordinal(rank)}
    />
  );
}

export function MorphemeInfoPanelDictionaryRankSection({
  infoBackCardSlice,
}: {
  infoBackCardSlice: InfoMorphemeSlice;
}) {
  const characterOrWordRank = useCardFrequencyRank(infoBackCardSlice);

  return (
    <View className="gap-1">
      <RankRow label={characterOrWordRankLabel(infoBackCardSlice)} rank={characterOrWordRank} />
    </View>
  );
}
